module.exports = __webpack_public_path__ + "static/micro-sitio-2-0abc69164d7bfa5ba5d9dcd34faeda18.png";